(()=>{
  const shell=document.querySelector('[data-it-gemstone-shell]');
  if(!shell)return;

  document.body.classList.add('it-gemstone-active');

  const nativeSelector='button,a,[role="button"]';
  const params=()=>new URLSearchParams(location.search);
  const detailId=()=>params().get('viewDetailsId')||'';
  const isDetail=()=>!!detailId();
  const norm=v=>(v||'').replace(/\s+/g,' ').trim().toLowerCase();
  const push=(event,extra={})=>{
    window.dataLayer=window.dataLayer||[];
    window.dataLayer.push({event,...extra,page_path:location.pathname+location.search});
  };

  const waMessage=()=>{
    const base=isDetail()?shell.dataset.itGemWhatsappDetail:shell.dataset.itGemWhatsappSource;
    const fallback=isDetail()
      ?"Hello Imperial Time, I'm interested in the coloured gemstone shown on this page and would like some additional information / photos / video."
      :"Hello Imperial Time, I'd like help sourcing a coloured gemstone.";
    return `${base||fallback} ${location.href}`;
  };

  const syncShell=()=>{
    const detail=isDetail();
    const hero=shell.querySelector('[data-it-gemstone-hero]');
    const detailbar=shell.querySelector('[data-it-gemstone-detailbar]');
    if(hero)hero.hidden=detail;
    if(detailbar)detailbar.hidden=!detail;
    document.querySelectorAll('[data-it-gemstone-whatsapp]').forEach(a=>{
      a.href='https://wa.me/447538174795?text='+encodeURIComponent(waMessage());
    });
  };

  const markNativeElement=el=>{
    if(!(el instanceof Element)||el.closest('[data-it-gemstone-shell],[data-it-gemstone-support]'))return;
    const label=norm(el.innerText||el.textContent);
    if(!label)return;

    if(label==='view gemstone'||label==='view details'||label==='details'){
      delete el.dataset.itGemEvent;
      return;
    }

    let event='';
    if(label.includes('filter')||label==='advanced filters')event='gemstone_filter_open';
    else if(label.includes('certificate')||label.includes('report'))event='gemstone_certificate_open';
    else if(label==='select'||label==='select gemstone'||label==='buy gemstone')event='gemstone_select';
    else if(label==='add to cart'||label==='add gemstone to cart')event='gemstone_add_to_cart';

    if(event)el.dataset.itGemEvent=event;
  };

  const enhanceNative=root=>{
    if(!(root instanceof Element)&&root!==document)return;
    if(root!==document&&root.matches(nativeSelector))markNativeElement(root);
    root.querySelectorAll(nativeSelector).forEach(markNativeElement);
  };

  let lastUrl=location.href;
  let lastDetailId=detailId();
  const syncUrlState=()=>{
    if(location.href===lastUrl)return;
    lastUrl=location.href;
    const nextDetailId=detailId();
    syncShell();
    if(nextDetailId&&nextDetailId!==lastDetailId){
      push('gemstone_detail_view',{source_route:'gemstones',gemstone_detail_id:nextDetailId});
    }
    lastDetailId=nextDetailId;
  };

  syncShell();
  enhanceNative(document);
  push('gemstone_source_view',{source_route:'gemstones'});
  if(lastDetailId)push('gemstone_detail_view',{source_route:'gemstones',gemstone_detail_id:lastDetailId});

  document.addEventListener('click',e=>{
    const explicit=e.target.closest('[data-it-event]');
    if(explicit)push(explicit.dataset.itEvent,{link_url:explicit.href||''});
    const native=e.target.closest('[data-it-gem-event]');
    if(native)push(native.dataset.itGemEvent,{link_url:native.href||''});
  });

  ['pushState','replaceState'].forEach(method=>{
    const original=history[method];
    if(typeof original!=='function')return;
    history[method]=function(){
      const result=original.apply(this,arguments);
      queueMicrotask(syncUrlState);
      return result;
    };
  });

  let queued=false;
  const pendingRoots=new Set();
  new MutationObserver(records=>{
    records.forEach(record=>record.addedNodes.forEach(node=>{
      if(node instanceof Element)pendingRoots.add(node);
    }));
    if(queued)return;
    queued=true;
    requestAnimationFrame(()=>{
      queued=false;
      syncUrlState();
      pendingRoots.forEach(enhanceNative);
      pendingRoots.clear();
    });
  }).observe(document.body,{subtree:true,childList:true});

  window.addEventListener('popstate',()=>{
    syncUrlState();
    syncShell();
  });
})();